export default __webpack_public_path__ + "static/media/Icons__fire2.ddbbedff.svg";